export const dubFactorAuthSettingsSelector = (state) => state.settings.doubleFactorAuth;
